import { useImage } from 'assets/use-image'
import React from 'react'
import styled from 'styled-components'
/* eslint-disable  @typescript-eslint/no-explicit-any  */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types*/

/* 
  Using svg as image
  import SomethingIcon from 'assets/....svg?react'
  <Image src={SomethingIcon} /> 
*/
export const Image = styled.img``

type CoverImageProps = {
  fileName: string
  additionalState: string
  alt: string
  [key: string]: any
}

export const CoverImage: React.FC<CoverImageProps> = ({
  fileName,
  additionalState,
  alt,
  className,
  ...rest
}) => {
  const { loading, error, image } = useImage(fileName, additionalState)

  if (loading)
    return (
      <div className={className}>
        <div role="status" aria-label={`Loading ${alt}`} />
      </div>
    )

  if (error)
    return (
      <div className={className}>
        <div role="alert" aria-label={`Error loading ${alt}`} />
      </div>
    )

  return <Image src={image} alt={alt} className={className} {...rest} />
}
